module.exports = __webpack_public_path__ + "img/appstore.0590fc01.png";